import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { format } from 'date-fns'

import * as common from '../../../../common'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.Scenario.Input,
    graphql.schema.ScenarioInput
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    period: graphql.transformers.IN.object({
      // AppSync requires date-only values, so normalize any draft date string
      // before sending it to GraphQL.
      endDate: ({ end }) =>
        end ? format(new Date(end), 'yyyy-MM-dd') : undefined,
      startDate: ({ start }) =>
        start ? format(new Date(start), 'yyyy-MM-dd') : undefined,
    }),
    purposes: {
      usingFullInput: graphql.transformers.IN.always(undefined),
    },
    variables: common.gql.dms.data.inputs.variableValue.TRANSFORMER,
    visibility: common.gql.admin.scenario.enums.scenarioVisibility.TRANSFORMER,
  }),
)
